import { render } from "./shoppingMallOrderDetail.vue?vue&type=template&id=f85a6dfa"
import script from "./shoppingMallOrderDetail.vue?vue&type=script&lang=js"
export * from "./shoppingMallOrderDetail.vue?vue&type=script&lang=js"

import "./shoppingMallOrderDetail.vue?vue&type=style&index=0&id=f85a6dfa&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__